export default "__VITE_ASSET__BlVEPPWc__"